// src/sectors/pilates/sessions/modals/packageUtils.js
export const fmtDate = (x) => (x ? new Date(x).toLocaleDateString('tr-TR') : '—');

export const pickActivePackage = (list = []) => {
  const arr = Array.isArray(list) ? list : [];

  // ✅ ACTIVE olanı tercih et
  const actives = arr.filter((p) => {
    const status = String(p?.status || '').toUpperCase();
    // "ACTIVE" varsa en iyi aday
    if (status === 'ACTIVE') return true;

    // fallback: ended/passive değil + endAt yok
    return status !== 'ENDED' && status !== 'PASSIVE' && !p?.endAt && !p?.endedAt;
  });

  // ✅ en yeni paketi seç (createdAt/startAt büyük olan)
  actives.sort((a, b) => {
    const ta = new Date(a?.createdAt || a?.startAt || 0).getTime();
    const tb = new Date(b?.createdAt || b?.startAt || 0).getTime();
    return tb - ta; // ✅ DESC
  });

  return actives[0] || null;
};

// backend shape: pkg.items = [{ id, activityName, totalSessions, usedSessions, totalMakeUp, usedMakeUp, totalGift, usedGift }]
export const normalizeItems = (pkg) => {
  const arr = Array.isArray(pkg?.items) ? pkg.items : [];
  return arr.map((it, idx) => {
    const totalSessions = Number(it?.totalSessions ?? 0);
    const usedSessions = Number(it?.usedSessions ?? 0);
    const remainingSessions = Math.max(0, totalSessions - usedSessions);

    const totalMakeUp = Number(it?.totalMakeUp ?? 0);
    const usedMakeUp = Number(it?.usedMakeUp ?? 0);
    const remainingMakeUp = Math.max(0, totalMakeUp - usedMakeUp);

    const totalGift = Number(it?.totalGift ?? 0);
    const usedGift = Number(it?.usedGift ?? 0);
    const remainingGift = Math.max(0, totalGift - usedGift);

    return {
      id: String(it?.id ?? idx),
      activityName: it?.activityName || `Aktivite ${idx + 1}`,

      totalSessions,
      usedSessions,
      remainingSessions,

      totalMakeUp,
      usedMakeUp,
      remainingMakeUp,

      totalGift,
      usedGift,
      remainingGift,
    };
  });
};

export const safeNum = (x) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : null;
};

export const calcRem = (total, used) => {
  const t = safeNum(total);
  const u = safeNum(used);
  if (t == null || u == null) return null;
  return Math.max(0, t - u);
};
